export default "__VITE_ASSET__4465050a__"